import {h} from 'preact';
import {Link, Route} from 'react-router-dom';
import {toTitleFromSlug} from '@util/StringUtils';

const breadcrumb = {
    root: 'w-full items-baseline relative overflow-hidden mt-0 py-4 border-b border-grey-lighter border-solid',
    nav: 'pad-content w-max mx-auto flex-1 ellipsis',
    title: 'flex-0 text-base normal mr-2 lg:mr-8',
    item: 'breadcrumb-item slash-forward hidden md:inline',
    tail: 'hidden md:inline font-bold'
};

export const Breadcrumbs = ( {basename = '', ...props} ) => {
    // todo -> refactor how breadcrumbs are rendered
    return (
        <div id="breadcrumb-nav" data-testid="breadcrumb-nav" className={`breadcrumb-nav ${breadcrumb.root}`}>
            <nav className={`breadcrumbs ${breadcrumb.nav}`}>
                <Route path="*/:path?" render={props =>
                    <span>
                    {basename.split( '/' ).map( ( path, i, arr ) =>
                        <StaticBreadcrumbItem
                            {...props}
                            path={i === 0 ? 'home' : arr[i]}
                            isLastItem={i === arr.length - 1}
                            basename={basename}
                            url={arr.slice( 0, i + 1 ).join( '/' )}/>
                    )}
                        {props.match.url.split( '/' ).map( ( path, i, arr ) => {
                            // skip the first item in array because it will always be empty
                            if ( i === 0 ) {
                                return null;
                            }
                            return <BreadcrumbItem
                                {...props}
                                path={arr[i]}
                                isLastItem={i === arr.length - 1}
                                basename={basename}
                                url={arr.slice( 0, i + 1 ).join( '/' )}/>
                        } )}
                </span>
                }/>
        </nav>
    </div>
    );
};

/*
// note -> example implementation
export default (props) => {
    const paths = props.pathname.split('/').map((p, i, arr) => {
        if (i === 0) return {
            key: i,
            content: (<Link to={'/'}>home</Link>),
            active: (i === arr.length - 1),
            link: (i < arr.length - 1)
        };

        if (i === arr.length - 1) return {
            key: i,
            content: p,
            active: (i === arr.length - 1)
        };

        return {
            key: i,
            content: (<Link to={`${arr.slice(0, i + 1).join('/')}`}>{p}</Link>),
            active: (i === arr.length - 1),
            link: (i < arr.length - 1)}
    };
);
    return <Breadcrumb icon='chevron right' sections={paths}/>;
};*/

const StaticBreadcrumbItem = ( {path, url, basename, isLastItem, ...props} ) => {
    const pageTitle = toTitleFromSlug( path || '' );
    return (isLastItem && props.match.url === '/')
        ? <span className={breadcrumb.tail}>{pageTitle}</span>
        : (url === basename)
            ? <Link className={breadcrumb.item} to={'/'}>{pageTitle}</Link>
            : <a className={breadcrumb.item} href={url}>{pageTitle}</a>;
};

const BreadcrumbItem = ( {path, url, basename, isLastItem, ...props} ) => {
    // fixme -> breadcrums items will strip "-" characters from text items such as SKU or Serial where we might
    //  want to keep these in some cases
    const pageTitle = toTitleFromSlug( path || '' );
    return isLastItem
        ? <span className={breadcrumb.tail}>{pageTitle}</span>
        : <Link className={breadcrumb.item} to={url || ''}>{pageTitle}</Link>;
};